/* eslint-disable react/no-multi-comp */

import React from 'react'
import QRCode from 'qrcode-react'
import { Modal, Panel } from 'react-bootstrap'
import { uniq, compact, isString } from 'lodash'
import { browserHistory } from 'react-router'
import { post } from 'superagent'

import DocPagesModal from './DocPagesModal.jsx'
import Button from '../components/Button.jsx'
import TripNamePicker from "../trips/TripNamePicker"

import getRouteWarnings from '../../lib/routeWarnings'

import { getMissingTitleErrors, getTripLength, getRouteLength } from '../../lib/TripTools'
import { l } from '../../lib/Tools.js'

import { nameOrTitle, getText, getTextWithTokens } from '../lib/text.js'

const getErrors = (trip, route, Activities, Cities) => {
  let errors = []
  const t = trip
  const tripDays = getTripLength(t)
  const routeDays = route ? getRouteLength(route) : 0

  // check dates
  if (!t.startDate) errors.push(getText("Falta la fecha inicial"))
  if (!t.endDate) errors.push(getText("Falta la fecha final"))

  if (tripDays != routeDays && !t.flexibleDates) {
    errors.push(`${getTextWithTokens("error_route_length", [tripDays, routeDays])}`)
  }

  // check cities' translations
  const missingCities = uniq(
    compact(route.agenda.filter(x => x.city && Cities[x.city] && !Cities[x.city].chinese))
  )
    .map(x => `${getTextWithTokens("error_city_title", [x.city])}`)

  if (missingCities && missingCities.length > 0) {
    errors = errors.concat(missingCities)
  }

  // títulos que faltan en chino (gastos y actividades)
  const missingTitles = getMissingTitleErrors(trip, route, Activities)
  if (missingTitles && missingTitles.length > 0) {
    errors.push({ 
      text: getText("error_missing_titles"),
      cases: missingTitles
    })
  }

  const routeWarnings = getRouteWarnings(route)

  // TODO remove this for loop; this aint C in 1995
  for (let i = 0; i < route.length; ++i) {
    if (routeWarnings[i]) {
      if (route.agenda[i].type === "activity") {
        errors.push({
          text: nameOrTitle(Activities[route.agenda[i].id]),
          cases: routeWarnings[i]
        })
      }
      else {
        errors.concat(routeWarnings[i])
      }
    }
  }

  return errors
}

const ErrorList = ({ cancel, go, errors }) => (
  <Modal show bsSize="large" onHide={cancel}>
    <Modal.Header closeButton>
      {errors.length > 1 ? getText("Errores") : getText("Error") }
    </Modal.Header>
    <Modal.Body>
      <ul>
        {
          // Allowed: key={i}. This list shoudlnt be changin, its in a modal.
          errors.map((e, i) => (isString(e)
            ? (<li key={i}>{e}</li>)
            : (<li key={i}>{e.text}<ul>{ e.cases.map((c, j) => (<li key={j}>{c}</li>)) }</ul></li>)
          ))
        }
      </ul>
    </Modal.Body>
    <Modal.Footer>
      <Button bsStyle="warning" onClick={() => go()}>
        {getText("Generar con errores")}
      </Button>
      <Button onClick={cancel}>{getText("Cerrar")}</Button>
    </Modal.Footer>
  </Modal>
)

const Result = ({ trip, cancel, urlu, urlc, advanceStatus }) => (
  <Modal show onHide={cancel}>
    <Modal.Header>
      Documento generado correctamente
    </Modal.Header>
    <Modal.Body>
      <Panel style={{width : '50%', textAlign : "center", display : "inline-block"}}>
        <Panel.Body>
          <h2 style={{marginBottom : "10px", marginTop : "-5px"}}>
            Sin comprimir
          </h2>
          <div>
            <QRCode value= {document.location.origin + urlu} logo={"/static/logo_no_letters.png"} size={256} logoWidth = {128} />
          </div>

          <output style={{maxWidth : '100%', wordWrap : "break-word"}}>
            {document.location.origin + urlu}
          </output>
        </Panel.Body>
      </Panel>
      <Panel style={{width : '50%', textAlign : "center", display : "inline-block"}}>
        <Panel.Body>
          <h2 style={{marginBottom : "10px", marginTop : "-5px"}}>
            Comprimido
          </h2>
          <div>
            <QRCode value= {document.location.origin + urlc} logo={"/static/logo_no_letters.png"} size={256} logoWidth = {128} />
          </div>
          <output style={{maxWidth : '100%', wordWrap : "break-word"}}>
            {document.location.origin + urlc}
          </output>
        </Panel.Body>
      </Panel>
    </Modal.Body>
    <Modal.Footer>
      {
        trip.status !== 10 ? ""
          : (
            <Button
              onClick={() => advanceStatus()}
            >
              {getText('Marcar viaje como "📬 Propuesta enviada"')}
            </Button>
          )
      }
      <Button
        bsStyle="primary"
        onClick={() => window.open(urlc)}
      >
        Descargar documento
      </Button>
      <Button
        onClick={cancel}
      >
        Cerrar
      </Button>
    </Modal.Footer>
  </Modal>
)

const Spinner = ({ text }) => (
  <Modal show bsSize="small">
    <Modal.Body>
      {text}
    </Modal.Body>
  </Modal>
)

class FileSelector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedIds: []
    }
  }

  render() {
    const { trip, route, Activities, Cities, generate, cancel } = this.props

    return (
      <DocPagesModal
        trip={trip}
        route={route}
        allActivities={Activities}
        Cities={Cities}
        onGenerate={selectedIds => generate(selectedIds) }
        onCancel={() => cancel()}
      />
    )
  }
}

const ModalNamePicker = props => (
  <Modal show onHide={() => props.cancel()}>
    <Modal.Body>
      <TripNamePicker {...props} />
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={() => props.cancel()}>Cancelar</Button>
      <Button bsStyle="primary" onClick={() => props.ok()}>OK</Button>
    </Modal.Footer>
  </Modal>
)

/**
 *
 */

export default class Propuesta extends React.PureComponent {
  constructor(props) {
    super(props)

    const errors = getErrors(props.trip, props.route, props.Activities, props.Cities)

    this.state = {
      errorsDismissed: false,
      urlu: null,
      urlc: null,
      generating: false,
      nameSelected: null,
      nameSelectionDone: false,
      fileSelectionDone: false,
      errors
    }
  }

  generate(id, selection, name) {
    this.setState({generating: true})
    post(`/api/doc1/${id}`)
      .send({ selection, name })
      .end((e, r) => {
        this.setState({ modal: null })
        if (r && r.statusCode === 412) {
          alert(l(`${getText("error_missing_files")} ${r.body.missingFilesNames.join(", ")}`))
        }
        else if (r.statusCode === 401) {
          alert(getText("error_expired_login"))
          browserHistory.push("/login")
        }
        else if (e) {
          alert(`${getText("error_pdf_generation")} ${e}`)
          console.error(e)
          console.error(r)
        }
        else {
          console.log(`got pdf: ${r.body.resultFile}`)
          this.setState({
            generating: false,
            urlu: `/${r.body.resultFileu}`,
            urlc: `/${r.body.resultFilec}`,
          })
        }
      })
  }

  render() {
    const {errors, errorsDismissed, urlu, urlc, generating} = this.state
    const {trip, route, cancel, advanceStatus, Activities, Cities} = this.props

    if (errors.length > 0 && !errorsDismissed) return (
      <ErrorList
        go={() => {
          this.setState({ errorsDismissed: true })
        }
        }
        cancel={() => cancel()}
        errors={errors}
      />
    )

    if (!generating && !this.state.fileSelectionDone && !urlc && (errors.length == 0 || errorsDismissed)) return (
      <FileSelector
        trip={trip}
        route={route}
        Activities={Activities}
        Cities={Cities}
        generate={fileSelection => this.setState({ fileSelectionDone: true, fileSelection })}
        cancel={() => cancel()}
      />
    )

    if (!generating && !this.state.nameSelectionDone) return (
      <ModalNamePicker
        trip={trip}
        value={this.state.nameSelected}
        onChange={(keyIgnored, nameSelected) => this.setState({ nameSelected })}
        config="propuesta"
        ok={(_key, _name) => {
          if (this.state.nameSelected) {
            this.setState({ nameSelectionDone: true })
            this.generate(trip._id, this.state.fileSelection, this.state.nameSelected)
          }
        }}
        cancel={() => cancel()}
      />
    )

    if (generating) {
      return (<Spinner text={getText("Generando documento...")} />)
    }

    if (urlc) return (
      <Result
        trip={trip}
        cancel={cancel}
        advanceStatus={advanceStatus}
        urlu={urlu}
        urlc={urlc}
      />
    )

    return null
  }
}
